// _getGlobalLocale :: Effect String
export function _getGlobalLocale() {
  return I18n.locale;
}
